import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allAccordingToParagraph: [],
    allMeasurements: [],
    loading: false,
    error: null,
};

const dropdownSlice = createSlice({
    name: 'dropdown',
    initialState,
    reducers: {
        setAllAccordingToParagraph: (state, action) => {
            state.allAccordingToParagraph = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        allMeasurements: (state, action) => {
            state.allMeasurements = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllAccordingToParagraph, allMeasurements } = dropdownSlice.actions;

export default dropdownSlice.reducer;